
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100.5 100.3"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M59.3 30.9c1.3.6 2.5 1.3 3.6 2.1.8.6 1.6 1.3 2.4 2.1.5.5.9 1 1.4 1.5.7.9 1.8 1.3 2.8 1.3.8 0 1.6-.3 2.3-.8 1.6-1.3 1.8-3.6.5-5.1-.6-.7-1.2-1.4-1.8-2-1-1-2.1-1.9-3.2-2.8-1.5-1.1-3.1-2.1-4.8-2.9-1.8-.9-4-.1-4.9 1.7-.9 1.9-.1 4.1 1.7 4.9z"}}),_c('path',{attrs:{"d":"M75.2 46.5H64c-1.6-6-7.2-10.5-13.7-10.5-7.8 0-14.2 6.4-14.2 14.2 0 7.8 6.4 14.2 14.2 14.2 6.6 0 12.1-4.5 13.7-10.5h7.3c-1.8 10.3-11 18.1-22 17.6-11.1-.5-20-9.6-20.3-20.7-.3-12 9.3-21.8 21.2-21.9 2 0 3.7-1.6 3.7-3.5.1-2.1-1.6-3.8-3.6-3.8-16.3 0-29.4 13.7-28.5 30.1.8 14.5 12.5 26.2 27 27 16.5.9 30.1-12.3 30.1-28.5-.1-2.1-1.7-3.7-3.7-3.7zM50.3 57.1c-3.8 0-6.9-3.1-6.9-6.9 0-3.8 3.1-6.9 6.9-6.9s6.9 3.1 6.9 6.9c0 3.8-3.1 6.9-6.9 6.9z"}})])])
          )
        }
      }
    